import { DefaultModel } from "../defaultModel";

export const CustomWidgetModel = DefaultModel.extend({
    isCustom: true,
    defaults: {
        widgetType: "custom.chargebackRateByNetwork",
        ...DefaultModel.prototype.defaults
    }
});
